import {
  apiV2EnergyCompareGetMediumIndicatorLossDataLossDetailPost,
  V2EnergyCompareGetMediumIndicatorLossDataLossDetailPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { DatePicker, Modal } from '@maxtropy/components';
import { DatePickerProps } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import React, { FC, useEffect, useMemo, useState } from 'react';
import Chart from '../Chart';
import { getLossDetailChartOption } from '../Chart/lossChartOptions';
import { LossDataPostItemResponse } from '../LossDuringTransAndDisProcess';
import { MediumIndicatorDisplayUnit } from '@/api/energyMedium';
import { TimePickerUtil } from '../LossDuringTransAndDisProcess/util';
import { TimeActive } from '../LossDuringTransAndDisProcess/type';

interface ILossDetailModal {
  lossDetailVisible: boolean;
  onCancel: () => void;
  selectedProcessName?: string;
  processId?: React.Key;
  currentSelectedLossBasicDetail?: LossDataPostItemResponse;
  mediumIndicatorDisplayUnitData?: MediumIndicatorDisplayUnit;
  activeKey: TimeActive;
}

const LossDetailModal: FC<ILossDetailModal> = props => {
  const {
    lossDetailVisible,
    onCancel,
    selectedProcessName,
    processId,
    currentSelectedLossBasicDetail,
    mediumIndicatorDisplayUnitData,
    activeKey,
  } = props;
  const [chartLoading, setChartLoading] = useState<boolean>(false);
  const [chartData, setChartData] = useState<V2EnergyCompareGetMediumIndicatorLossDataLossDetailPostResponse>();
  const [date, setDate] = useState<Dayjs>();
  const picker = useMemo(() => TimePickerUtil(activeKey), [activeKey]);
  useEffect(() => {
    if (lossDetailVisible) {
      if (
        currentSelectedLossBasicDetail &&
        currentSelectedLossBasicDetail.maxLossRateTs &&
        currentSelectedLossBasicDetail.energyMediumId
      ) {
        setDate(dayjs(currentSelectedLossBasicDetail.maxLossRateTs as string).startOf('day'));
      } else {
        setDate(dayjs().startOf('day'));
      }
    }
  }, [currentSelectedLossBasicDetail, lossDetailVisible]);

  const disabledDate = (current: Dayjs) => {
    return current && current >= dayjs().endOf('day');
  };

  const onChangePicker: DatePickerProps['onChange'] = (date, dateString) => {
    if (date) {
      setDate(date);
    }
  };
  //
  useEffect(() => {
    if (processId && date) {
      setChartLoading(true);
      apiV2EnergyCompareGetMediumIndicatorLossDataLossDetailPost({
        energyMediumId: currentSelectedLossBasicDetail?.energyMediumId,
        processId: Number(processId),
        timeResolution: activeKey,
        from: date.startOf('day').valueOf(),
        to:
          activeKey === TimeActive.CUSTOM
            ? date.endOf('day').valueOf()
            : dayjs(
                activeKey === TimeActive.THIS_WEEK
                  ? date.endOf('week').valueOf()
                  : activeKey === TimeActive.THIS_MONTH
                  ? date.endOf('month').valueOf()
                  : date.endOf('day').valueOf()
              ).valueOf(),
      }).then(res => {
        setChartData(res);
        setChartLoading(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processId, date]);

  const option = useMemo(
    () =>
      getLossDetailChartOption(
        currentSelectedLossBasicDetail?.energyMediumIndicatorId,
        chartData,
        mediumIndicatorDisplayUnitData
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [chartData]
  );

  return (
    <Modal
      open={lossDetailVisible}
      title={`${selectedProcessName ?? '--'}/${currentSelectedLossBasicDetail?.energyMediumName ?? '--'}损耗详情`}
      size="big"
      destroyOnClose
      footer={null}
      onCancel={onCancel}
    >
      <div>
        <span>时间：</span>
        <DatePicker
          value={date}
          disabledDate={disabledDate}
          onChange={onChangePicker}
          allowClear={false}
          picker={picker}
        />
      </div>
      <div style={{ marginTop: 20 }}>
        <Chart
          height={450}
          loading={chartLoading}
          chartData={chartData?.exitDataDetailList || chartData?.entryDataDetailList}
          option={option}
        />
      </div>
    </Modal>
  );
};

export default LossDetailModal;
